module.exports = __webpack_public_path__ + "img/Avatar-9.b47b9dcc.svg";